<template>
  <div v-if="policyDetails !== null" data-test-level-two-details>
    <!-- Level 2 - price -->
    <section
      v-if="policyDetails.policyActiveStatusEnum !== 3"
      data-test-price-row
      class="row policy-section-row-small hide-for-large"
    >
      <div class="columns policy-section-label small-12 medium-6 large-4">
        <h4 data-test-price-header v-html="policyDetails.titlePrice" />
      </div>
      <div class="columns medium-6 large-5">
        <div class="policy-price-text">
          <span v-html="policyDetails.priceFormatted" />
          <span v-html="policyDetails.paymentFrequencyPriceDescription" />
        </div>

        <div
          class="color-gray policy-price-text"
          policy-level-two-price-disclaimer
          v-html="policyDetails.priceDisclaimer"
        />

        <span class="color-gray" data-test-interval v-html="policyDetails.paymentIntervalText" />
      </div>
    </section>
    <!-- Level 2 - missing payments -->
    <payment-section
      v-if="policyDetails.missingPayments.payments.length > 0"
      :payment-details="policyDetails.missingPayments"
    />

    <!--previous payment-->
    <payment-section
      v-if="policyDetails.previousPayments.payments.length > 0"
      :payment-details="policyDetails.previousPayments"
    />

    <!-- Level 2 - next payment -->
    <payment-section
      v-if="policyDetails.nextPayment.payments.length > 0"
      :payment-details="policyDetails.nextPayment"
      data-test-policy-next-payment-section
    />

    <!-- Level 2 - covers -->
    <section class="row policy-section-row" data-test-policy-coverages-section>
      <div class="columns policy-section-label small-12 medium-6 large-3">
        <h4 data-test-policy-coverages-label v-html="policyDetails.titleCovers" />
      </div>
      <div
        class="columns medium-6 large-5 policy-section-view-list policy-section-align"
        data-test-policy-coverages-row
      >
        <div
          v-for="(coverSection, index) in policyDetails.coversModel"
          :key="'cover-section-' + index"
        >
          <div
            v-if="coverSection.name"
            class="row"
            data-test-policy-coverages-cover-type="cover-group"
            :data-test-policy-coverages-cover-group="coverSection.name"
          >
            <LabelAndTooltip
              class="columns policy-cover-row-title"
              :label="coverSection.name"
              :tooltip="coverSection.tooltip"
            />
            <div class="columns" />
          </div>

          <covers
            v-for="(cover, index) in coverSection.coverElements"
            :key="'cover-' + index"
            :cover-info="cover"
          />
        </div>
      </div>
    </section>

    <!-- Level 2 - deductible - not all products show this -->
    <section
      v-if="policyDetails.showDeductible"
      class="row policy-section-row"
      data-test-policy-deductible-section
    >
      <div class="columns policy-section-label small-12 medium-6 large-3">
        <h4 data-test-policy-deductible-label v-html="policyDetails.titleDeductible" />
      </div>
      <div
        class="columns medium-6 large-5 policy-section-align"
        data-test-policy-deductible-amount
        data-tag-amount
        v-html="policyDetails.deductibleFormatted"
      />
    </section>

    <!-- Level 2 - special circumstances text which is only shown if there is any text to show -->
    <div
      v-if="policyDetails.hasSpecialCircumstances"
      data-test-special-cicumstances-row
      class="row policy-section-row"
    >
      <div class="columns policy-section-label small-12 medium-expand">
        <div class="info-message">
          <span class="icon-error policy-error-icon" />
          <span data-test-special-circumstances v-html="policyDetails.specialCircumstancesText" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';
import Covers from './Covers.vue';
import PaymentSection from './PaymentSection.vue';

export default {
  components: {
    Covers,
    LabelAndTooltip,
    PaymentSection
  },
  props: {
    policyDetails: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
